import Vue from 'vue'
import Router from 'vue-router'

import Layout from '../components/feige/Layout'
import LayoutCustomer from '../components/feige/customer/LayoutCustomer'
import DefaultLayout from '@/components/DefaultLayout'

import ticketRouter from './ticket'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',

  routes: [
    {
      path: '*',
      component: () => import(/* webpackChunkName: "404" */ '@/views/404')
    },
    {
      path : '/',
      redirect: '/ticket-vue'
    },
    {
        path: '/ticket-vue/hawkeye_ticket_view',
        component: () => import(/* webpackChunkName: "hawkeye_ticket_view" */ '@/views/hawkeye/hawkeye_ticket_view')
    },
    {
        path: '/ticket-vue/hawkeye_ticket_new',
        component: () => import(/* webpackChunkName: "hawkeye_ticket_new" */ '@/views/hawkeye/hawkeye_ticket_new')
    },
    {
        path: '/ticket-vue/help',
        component: () => import(/* webpackChunkName: "help" */ '@/views/help')
    },
    {
        path: '/ticket-vue/badge',
        component: () => import(/* webpackChunkName: "badge" */ '@/views/badge')
    },
    {
        path: '/ticket-vue/bind-work-weixin',
        component: () => import(/* webpackChunkName: "badge" */ '@/views/bind-work-weixin')
    },
    {
        path: '/ticket-vue/merchant-ticket',
        component: () => import(/* webpackChunkName: "merchant-ticket" */ '@/views/merchant-ticket')
    },
    {
        path: '/ticket-vue/about',
        component: () => import(/* webpackChunkName: "about" */ '@/views/about')
    },
    {
        path: '/ticket-vue/organization',
        component: () => import(/* webpackChunkName: "organization" */ '@/views/organization')
    },
    {
      path: '/ticket-vue/feige/merchant',
      redirect: '/ticket-vue/feige/merchant/index',
      component: Layout,
      children: [
        {
            path: 'index',
            component: () => import(/* webpackChunkName: "setting" */ '@/views/feige/index'),
            meta: { title: '全部工单', icon: 'example' }
        }
      ]
    },
    {
      path: '/ticket-vue/feige/merchant/wait',
      redirect: '/ticket-vue/feige/merchant/wait/index',
      component: Layout,
      children: [
        {
            path: 'index',
            component: () => import(/* webpackChunkName: "setting" */ '@/views/feige/index'),
            meta: { title: '待处理工单', icon: 'example' }
        }
      ]
    },
    {
      path: '/ticket-vue/feige/merchant/inprogress',
      redirect: '/ticket-vue/feige/merchant/inprogress/index',
      component: Layout,
      children: [
        {
            path: 'index',
            component: () => import(/* webpackChunkName: "setting" */ '@/views/feige/index'),
            meta: { title: '处理中的工单', icon: 'example' }
        }
      ]
    },
    {
      path: '/ticket-vue/feige/merchant/resolved',
      redirect: '/ticket-vue/feige/merchant/resolved/index',
      component: Layout,
      children: [
        {
            path: 'index',
            component: () => import(/* webpackChunkName: "setting" */ '@/views/feige/index'),
            meta: { title: '已解决工单', icon: 'example' }
        }
      ]
    },
    {
      path: '/ticket-vue/feige/merchant/close',
      redirect: '/ticket-vue/feige/merchant/close/index',
      component: Layout,
      children: [
        {
            path: 'index',
            component: () => import(/* webpackChunkName: "setting" */ '@/views/feige/index'),
            meta: { title: '已关闭工单', icon: 'example' }
        }
      ]
    },
    {
      path: '/ticket-vue/feige/merchant/detail',
      redirect: '/ticket-vue/feige/detail/feigeDetail',
      component: Layout,
      hidden: true,
      children: [
        {
            path: 'feigeDetail',
            component: () => import(/* webpackChunkName: "setting" */ '@/views/feige/detail'),
            hidden: true,
            meta: { title: '工单详情', icon: 'example' }
        }
      ]
    },
    {
      path: '/ticket-vue/feige/customer/login',
      component: () => import(/* webpackChunkName: "setting" */ '@/views/feige/customer/blankLogin')
    },
    {
      path: '/ticket-vue/feige/customer/index',
      redirect: '/ticket-vue/feige/customer/index/index',
      component: LayoutCustomer,
      children: [
        {
            path: 'index',
            component: () => import(/* webpackChunkName: "setting" */ '@/views/feige/customer/index'),
            meta: { title: '全部工单', icon: 'example' }
        }
      ]
    },
    {
      path: '/ticket-vue/feige/customer/index',
      redirect: '/ticket-vue/feige/customer/index/wait',
      component: LayoutCustomer,
      children: [
        {
            path: 'wait',
            component: () => import(/* webpackChunkName: "setting" */ '@/views/feige/customer/index'),
            meta: { title: '待处理工单', icon: 'example' }
        }
      ]
    },
    {
      path: '/ticket-vue/feige/customer/inprogress',
      redirect: '/ticket-vue/feige/customer/inprogress/index',
      component: LayoutCustomer,
      children: [
        {
            path: 'index',
            component: () => import(/* webpackChunkName: "setting" */ '@/views/feige/customer/index'),
            meta: { title: '处理中的工单', icon: 'example' }
        }
      ]
    },
    {
      path: '/ticket-vue/feige/customer/resolved',
      redirect: '/ticket-vue/feige/customer/resolved/index',
      component: LayoutCustomer,
      children: [
        {
            path: 'index',
            component: () => import(/* webpackChunkName: "setting" */ '@/views/feige/customer/index'),
            meta: { title: '已解决工单', icon: 'example' }
        }
      ]
    },
    {
      path: '/ticket-vue/feige/customer/close',
      redirect: '/ticket-vue/feige/customer/close/index',
      component: LayoutCustomer,
      children: [
        {
            path: 'index',
            component: () => import(/* webpackChunkName: "setting" */ '@/views/feige/customer/index'),
            meta: { title: '已关闭工单', icon: 'example' }
        }
      ]
    },
    ticketRouter
  ],

  scrollBehavior (to, from, savedPosition) {
    console.log('#46 scrollBehavior', to, from, savedPosition);

    return { x: 0, y: 0 }
  }
})


// WEBPACK FOOTER //
// ./src/router/index.js